<template>
  <div class="container">
    <img class="bottomImg" src="../assets/inputname_bottom.png"/>
    <img class="topImg" src="../assets/inputname_top.png"/>
    <div class="mainContainer">
      <input type="text" maxlength="4" placeholder="限4个字以内" v-model="name" @focus="inputFocus" @blur="inputBlur"/>
    </div>
    <button class="confirmBtn" @click="confirm"></button>
    <img class="pinkBall" src="../assets/pink_ball.png"/>
    <img class="pinkBall2" src="../assets/pink_ball.png"/>
  </div>
</template>
<script>
import FilterWord from '../store/keyWord.js'
export default {
  data () {
    return {
      name: ''
    }
  },
  methods: {
    confirm () {
      if(this.name === '' || this.name.trim() === ''){
        this.$store.commit('setName', '我');
        this.$router.replace({path:'/share'})
      }
      else{
        if(FilterWord.filterWord(this.name)){
          alert('内容包含敏感词汇');
          this.name = ''
        }else{
          this.$store.commit('setName', this.name);
          this.$router.replace({path:'/share'})
        }
      }
    },
    inputFocus () {
      let bheight = document.getElementById('app').clientHeight;
      document.getElementsByClassName('container')[0].style.height = bheight + 'px';
    },
    inputBlur () {
      let bheight = document.getElementById('app').clientHeight;
      document.getElementsByClassName('container')[0].style.height = bheight + 'px';
      window.scroll(0,0);
    },
  }
}
</script>
<style scoped>
.container{
  width: 100%;
  height: 100%;
  background: #aed1b8;
  padding-top: 5.4rem;
  box-sizing: border-box;
  margin: 0 auto;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
}
.confirmBtn{
  appearance: none;
  width: 3.35rem;
  height: 1.02rem;
  background: url(../assets/confirm_btn_name.png) no-repeat;
  background-size: 100% 100%;
  display: block;
  margin: 3rem auto 0;
  padding: 0;
  outline: none;
  border: none;
  position: relative;
}
.confirmBtn::after{
  content: '';
  width: 0.72rem;
  height: 0.25rem;
  position: absolute;
  top: 0.15rem;
  left: -0.36rem;
  background: url(../assets/confirm_btn_left.png) no-repeat;
  background-size: 100% 100%;
}
.mainContainer{
  width: 7.5rem;
  position: relative;
  z-index: 1;
  margin: 0 auto;
}
.mainContainer input{
  width: 3.7rem;
  height: 0.55rem;
  font-size: 0.33rem;
  line-height: 0.55rem;
  letter-spacing: 0.05rem;
  border: none;
  outline: none;
  border-bottom: 0.011rem solid #000;
  background-color: transparent;
  margin-left: 2.1rem;
  display: block;
  text-align: center;
}
.topImg{
  width: 8.4rem;
  height: 8.31rem;
  position: absolute;
  top: 0;
  right: 50%;
  transform: translateX(4.65rem);
}
.bottomImg{
  width: 100%;
  height: 8.52rem;
  position: absolute;
  bottom: 0;
  left: 0;
}
.pinkBall{
  position: absolute;
  width: 0.88rem;
  height: 0.88rem;
  right: 0.35rem;
  bottom: 1.9rem;
}
.pinkBall2{
  position: absolute;
  width: 0.44rem;
  height: 0.44rem;
  right: 2.5rem;
  bottom: 0.85rem;
}
</style>
